import React, { useCallback } from 'react';

import type { IScheduleBlock, ISortedGroupedSchedule, ISortedShift } from '@/types/schedule';
import type { IWeekDay } from '@/types/calendar';
import type { BaseShiftProps } from '@/components/agent/my-schedule';
import type { Hue } from '@/types/styles';

import { Shift, ShiftOffer, ShiftVto } from '@/components/agent/my-schedule';
import { ShiftAssignStatus } from '@/store/enums';

interface IShiftsContainer {
  shifts: IScheduleBlock[];
  contract: ISortedShift<ISortedGroupedSchedule>;
  blockColor: Hue;
  displayDetails: boolean;
  modal: BaseShiftProps['modal'];
  onClick: (() => void) | undefined;
  isDlsBlocked: boolean;
  day: IWeekDay;
}

const ShiftsContainer = ({
  blockColor,
  contract,
  displayDetails,
  shifts,
  modal,
  onClick,
  isDlsBlocked,
  day,
}: IShiftsContainer): React.ReactElement => {
  const getCommonProps = useCallback(
    (shift: IScheduleBlock) => ({
      block: shift,
      contract,
      blockColor,
      modal,
      onClick,
      isDlsBlocked,
      day,
    }),
    [blockColor, contract, day, isDlsBlocked, modal, onClick],
  );
  return (
    <>
      {shifts.map(shift => {
        if (shift.shiftAssnStatus > ShiftAssignStatus.offered) {
          return <ShiftVto key={shift.startBlock} {...getCommonProps(shift)} />;
        }

        if (shift.isOffered) {
          return <ShiftOffer key={shift.startBlock} {...getCommonProps(shift)} />;
        }

        return <Shift key={shift.startBlock} {...getCommonProps(shift)} isVisible={displayDetails} />;
      })}
    </>
  );
};

export { ShiftsContainer };
